import React from 'react';
import { MdSearch, MdFilterList } from 'react-icons/md';
import { 
  IncidentFilterHeader,
  FilterSection,
  FilterContainer,
  FilterInputContainer,
  FilterSelectContainer,
  FilterDateContainer,
  CustomInputGroup,
  SearchIconBox,
  CustomFormControl,
  CustomSelect,
  CustomDateInput,
  CustomButton
} from '../styles';

const IncidentFilters = ({ 
  filters, 
  onFilterChange, 
  incidentTypes, 
  severityLevels, 
  statusOptions 
}) => {
  const hasActiveFilters = Object.values(filters).some(value => value !== '');

  const clearAllFilters = () => {
    onFilterChange('search', '');
    onFilterChange('status', '');
    onFilterChange('incidentType', '');
    onFilterChange('severityLevel', '');
    onFilterChange('startDate', '');
    onFilterChange('endDate', '');
  };

  return (
    <IncidentFilterHeader id='incident-filter-header'>
      <FilterSection id='incident-filter-section'>
        <FilterContainer id='filter-container'>
          <FilterInputContainer id='filter-input-container'>
            <CustomInputGroup id='search-input'>
              <SearchIconBox>
                <MdSearch />
              </SearchIconBox>
              <CustomFormControl
                type="text"
                placeholder="Buscar por título, número ou descrição..."
                value={filters.search}
                onChange={(e) => onFilterChange('search', e.target.value)}
              />
            </CustomInputGroup>
          </FilterInputContainer>
          
          <FilterSelectContainer id='filter-status-container'>
            <CustomSelect
              value={filters.status}
              onChange={(e) => onFilterChange('status', e.target.value)}
            >
              <option value="">Busque por status...</option>
              {statusOptions.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </CustomSelect>
          </FilterSelectContainer>
          
          <FilterSelectContainer id='filter-type-container'>
            <CustomSelect
              value={filters.incidentType}
              onChange={(e) => onFilterChange('incidentType', e.target.value)}
            >
              <option value="">Busque por tipo...</option>
              {incidentTypes.map(type => (
                <option key={type.value} value={type.value}>
                  {type.label}
                </option>
              ))}
            </CustomSelect>
          </FilterSelectContainer>
          
          <FilterSelectContainer id='filter-severity-container'>
            <CustomSelect
              value={filters.severityLevel}
              onChange={(e) => onFilterChange('severityLevel', e.target.value)}
            >
              <option value="">Busque por severidade...</option>
              {severityLevels.map(level => (
                <option key={level.value} value={level.value}>
                  {level.label}
                </option>
              ))}
            </CustomSelect>
          </FilterSelectContainer>
          
          <FilterDateContainer id='filter-date-start-container'>
            <CustomDateInput
              type="date"
              value={filters.startDate}
              onChange={(e) => onFilterChange('startDate', e.target.value)}
              placeholder="dd/mm/aaaa"
            />
          </FilterDateContainer>
          
          <FilterDateContainer id='filter-date-end-container'>
            <CustomDateInput
              type="date"
              value={filters.endDate}
              onChange={(e) => onFilterChange('endDate', e.target.value)}
              placeholder="dd/mm/aaaa"
            />
          </FilterDateContainer>
          {hasActiveFilters && (
            <CustomButton id='incident-clear-filters-btn' onClick={clearAllFilters}>
              <MdFilterList />
              Limpar Filtros
            </CustomButton>
          )}
        </FilterContainer>
      </FilterSection>
    </IncidentFilterHeader>
  );
};

export default IncidentFilters;
